import { forwardRef } from 'react';

import type * as ToastPrimitives from '@radix-ui/react-toast';

import { ToastAction } from '@quick/components/Toaster';
import { useClipboard } from '@quick/utils';

import { useAppTranslation } from '@/app/i18n/client';

export const ToastActionCopy = forwardRef<
  React.ElementRef<typeof ToastPrimitives.Action>,
  {
    msg: string;
  }
>(({ msg, ...props }, ref) => {
  const { t } = useAppTranslation('common');
  const { copied, copy } = useClipboard(msg);
  const text = t(copied ? 'copied' : 'copy');
  return (
    <ToastAction
      ref={ref}
      {...props}
      onClick={(e) => {
        e.stopPropagation();
        copy();
      }}
      onClickCapture={(e) => {
        e.stopPropagation();
        copy();
      }}
      altText={text}
      type="button"
    >
      {text}
    </ToastAction>
  );
});
ToastActionCopy.displayName = ToastAction.displayName;
